<template>
  <div>
    <Label class="text-sm font-medium mb-2 block">Crop (%)</Label>
    <div class="grid grid-cols-4 gap-2">
      <InheritedField
        label="Top"
        :is-inherited="isInherited"
        :is-overridden="topOverridden"
        :parent-scene-name="parentSceneName"
        @reset="$emit('resetField', 'crop.top')"
      >
        <template #default="{ showInheritedBorder }">
          <NumberField :model-value="crop.top" @update:model-value="updateCrop('top', $event)">
            <NumberFieldContent>
              <NumberFieldInput 
                class="h-8" 
                :class="{ 'border-orange-400': showInheritedBorder }"
              />
            </NumberFieldContent>
          </NumberField>
        </template>
      </InheritedField>

      <InheritedField
        label="Right"
        :is-inherited="isInherited"
        :is-overridden="rightOverridden"
        :parent-scene-name="parentSceneName"
        @reset="$emit('resetField', 'crop.right')"
      >
        <template #default="{ showInheritedBorder }">
          <NumberField :model-value="crop.right" @update:model-value="updateCrop('right', $event)">
            <NumberFieldContent>
              <NumberFieldInput 
                class="h-8"
                :class="{ 'border-orange-400': showInheritedBorder }"
              />
            </NumberFieldContent>
          </NumberField>
        </template>
      </InheritedField>

      <InheritedField
        label="Bottom"
        :is-inherited="isInherited"
        :is-overridden="bottomOverridden"
        :parent-scene-name="parentSceneName"
        @reset="$emit('resetField', 'crop.bottom')"
      >
        <template #default="{ showInheritedBorder }">
          <NumberField :model-value="crop.bottom" @update:model-value="updateCrop('bottom', $event)">
            <NumberFieldContent>
              <NumberFieldInput 
                class="h-8"
                :class="{ 'border-orange-400': showInheritedBorder }"
              />
            </NumberFieldContent>
          </NumberField>
        </template>
      </InheritedField>

      <InheritedField
        label="Left"
        :is-inherited="isInherited"
        :is-overridden="leftOverridden"
        :parent-scene-name="parentSceneName"
        @reset="$emit('resetField', 'crop.left')"
      >
        <template #default="{ showInheritedBorder }">
          <NumberField :model-value="crop.left" @update:model-value="updateCrop('left', $event)">
            <NumberFieldContent>
              <NumberFieldInput 
                class="h-8"
                :class="{ 'border-orange-400': showInheritedBorder }"
              />
            </NumberFieldContent>
          </NumberField>
        </template>
      </InheritedField>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Label } from '@/components/ui/label'
import InheritedField from './InheritedField.vue'
import {
  NumberField,
  NumberFieldContent,
  NumberFieldInput,
} from '@/components/ui/number-field'

interface Crop {
  top: number
  right: number
  bottom: number
  left: number
}

interface Props {
  crop: Crop
  isInherited?: boolean
  topOverridden?: boolean
  rightOverridden?: boolean
  bottomOverridden?: boolean
  leftOverridden?: boolean
  parentSceneName?: string
}

const props = defineProps<Props>()

const emit = defineEmits<{
  update: [crop: Crop]
  resetField: [fieldPath: string]
}>()

const updateCrop = (side: keyof Crop, value: number) => {
  emit('update', { ...props.crop, [side]: value })
}
</script>
